import { gql } from '@apollo/client';

const UPDATE_USER_EMAIL = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfileV2(input: $input) {
      personalInfo {
        contactInfo {
          alternateEmail
        }
      }
    }
  }
`;

export default UPDATE_USER_EMAIL;
